import 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.featuregroup.subgroup'

import SubLayer from './SubLayer.js'

class Layer {
  popupCreator = null
  subLayerClass = SubLayer
  vm = null
  opts = {}

  constructor(
    map,
    config,
    opts = { vm: null, popupCreator: null, subLayerClass: null }
  ) {
    this.opts = opts
    this.vm = opts.vm
    this.popupCreator = opts.popupCreator
    this.subLayerClass = opts.subLayerClass || this.subLayerClass
    this._map = map
    this._layers = {}
    this.parseConfig(config)

    map.addLayer(this.cluster)
  }

  remove() {
    for (let key in this._layers) {
      this._layers[key].remove()
    }
  }

  parseConfig(config) {
    this.config = config
    this.cluster = L.markerClusterGroup({
      iconCreateFunction: config.divIcon,
      showCoverageOnHover: false,
    })
    // @fix: #12429
    this.cluster.on('spiderfied', function (a) {
      if (a.cluster && a.cluster.options && a.cluster.options.icon) {
        a.cluster.options.icon.setOpacity(0)
        a.cluster.options.icon._icon.style.zIndex = 0
      }
    })

    this.setCheckbox(config.checkbox)
    for (let i in config.groups) {
      let item = config.groups[i]
      item.layer = L.featureGroup.subGroup(this.cluster)
      item.parent = this
      item.id = i

      this._layers[i] = new this.subLayerClass(this._map, item, {
        popupCreator: this.popupCreator,
        vm: this.vm,
      })
    }
  }

  showLayer(id) {
    if (!this._layers.hasOwnProperty(id)) return false
    this._layers[id].show()
  }

  hideLayer(id) {
    if (!this._layers.hasOwnProperty(id)) return false
    this._layers[id].hide()
  }

  toggle(id) {
    if (!this._layers.hasOwnProperty(id)) return false
    this._layers[id].toggle()
  }

  setCheckbox(checkbox) {
    this._checkbox = checkbox
  }
}

export default Layer
